// Backend keys from permissions.json → Communication → Inbox (phase 4A/4C, premium plan).
// `manage` sees/assigns/resolves/replies to every conversation; `reply` sees/replies only to
// conversations assigned to the caller (enforced by InboxAccess in the Application layer, not
// just the controller — the frontend gate here is a UX convenience, never the source of truth).
export const INBOX_PERMISSIONS = {
  manage: "Communication.Inbox.manage",
  reply: "Communication.Inbox.reply",
} as const;
